<template>
  <div id="app">
    <Header />
    <div class="mainBody">
      <router-view></router-view>
    </div>
    <PopupModal></PopupModal>
    <AlertModal></AlertModal>
    <ConfirmModal></ConfirmModal>
    <ModalRejectAlarm />
    <ModalNotifyMatching />
    <MFooter />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Header from "@/components/layout/header/Header";
import MFooter from "@/components/layout/MFooter";
import AlertModal from "@/components/modal/AlertModal";
import ConfirmModal from "@/components/modal/ConfirmModal";
import PopupModal from "@/components/modal/PopupModal";
import ModalRejectAlarm from "@/components/managementPopup/ModalRejectAlarm";
import * as jwtUtil from "@/utils/jwtUtil";

export default {
  name: "App",
  components: {
    Header,
    MFooter,
    PopupModal,
    AlertModal,
    ConfirmModal,
    ModalRejectAlarm,
    ModalNotifyMatching,
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions("auth", ["getProfileRejectNotices"]),
    ...mapMutations("auth", ["setShowNoti", "setRejectNoties"]),
  },
  computed: {
    ...mapState("auth", ["rejectNoties"]),
  },
  mounted() {
    const that = this;

    const channel_service = this.$pusher.subscribe(
      "update-state-service-channel",
    );
    channel_service.bind("update-state-service-event", () => {
      const user = that.$store.state.auth.user;
      if (!this.lodash.isEmpty(user) && user.roleName == "ROLE_CORP") {
        that.$modal.show("modal-reject-alarm");
        that
          .getProfileRejectNotices()
          .then(() => {
            const reject = that.$store.state.auth.rejectNoties;
            if (reject.length > 0) {
              that.setShowNoti(true);
              that.$modal.show("modal-reject-alarm");
            }
          })
          .catch(() => {});
      }
    });

    const channel_project = this.$pusher.subscribe(
      "update-state-product-channel",
    );
    channel_project.bind("update-state-product-event", () => {
      const user = that.$store.state.auth.user;
      if (!this.lodash.isEmpty(user) && user.roleName == "ROLE_CORP") {
        that.$modal.show("modal-reject-alarm");
        that
          .getProfileRejectNotices()
          .then(() => {
            const reject = that.$store.state.auth.rejectNoties;
            if (reject.length > 0) {
              that.setShowNoti(true);
              that.$modal.show("modal-reject-alarm");
            }
          })
          .catch(() => {});
      }
    });

    const user = this.$store.state.auth.user;
    if (user && user.idx && [ROLE.CORP, ROLE.USER].includes(user.roleName)) {
      const channel_matching = this.$pusher.subscribe(
        "channel-update-state-matching-" + user.idx,
      );

      channel_matching.bind(
        "event-update-state-matching-" + user.idx,
        async (id) => {
          const detail = await this.$store.dispatch("getDirectDetail", id);
          if (!detail || !detail.requested) return;

          let rejectNoties = this.lodash.cloneDeep(this.rejectNoties);
          rejectNoties.unshift({
            ...detail,
            type: "matching",
          });

          this.setShowNoti(true);
          this.setRejectNoties(rejectNoties);

          this.$modal.show("modal-notify-matching");

          if (this.$route.path.toLocaleLowerCase().includes("mymatching")) {
            const status =
              localStorage.getItem(keyStorage.matchingStatus) || "";
            this.$store.dispatch("matching/loadReceivedMatching", {
              requestedIdx: user.idx,
              status: status,
            });
            this.$store.dispatch("matching/loadReceivedMatching", {
              requesterIdx: user.idx,
              status: status,
            });
          }
        },
      );
    }

    // const channel = this.$pusher.subscribe("update-state-service-channel");
    // channel.bind("update-state-service-event", () => {
    //   const user = that.$store.state.auth.user;
    //   console.log("update-state-service-channel ====>");
    //   console.log(user);
    //   if (!this.lodash.isEmpty(user) && user.roleName == "ROLE_CORP") {
    //     that.$modal.show("modal-reject-alarm");
    //     that
    //       .getProfileRejectNotices()
    //       .then(() => {
    //         const reject = that.$store.state.auth.rejectNoties;
    //         if (reject.length > 0) {
    //           that.$modal.show("modal-reject-alarm");
    //         }
    //       })
    //       .catch(() => {});
    //   }
    // });
  },
  created() {
    window.refreshInterval = setInterval(() => {
      var jwt = localStorage.getItem(jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN);
      if (!this.lodash.isEmpty(jwt)) {
        // Access Token 검증
        var payload = jwtUtil.parsePayload(jwt);

        const nextTime = new Date(payload.exp * 1000) - 300;
        if (nextTime >= new Date().getTime()) {
          this.$store.dispatch("auth/refreshAccessToken");
        }
      }
    }, 600000);
  },
  beforeDestroy() {
    if (window.refreshInterval) {
      clearInterval(window.refreshInterval);
    }
  },
};

import { initializeApp } from "firebase/app";
import { directStatus, keyStorage } from "./data/constances";
import { ROLE } from "./data/role";
import ModalNotifyMatching from "./components/notify/ModalNotifyMatching.vue";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then(() => {
      // console.log("SW registered!", reg)
    })
    .catch((err) => console.log("Boo!", err));
}

const firebaseConfig = {
  apiKey: "AIzaSyAF209K8PNZCnfEa8SWMgDsbCxH4vqsbBA",
  authDomain: "napproject-7bab9.firebaseapp.com",
  projectId: "napproject-7bab9",
  storageBucket: "napproject-7bab9.appspot.com",
  messagingSenderId: "928408581054",
  appId: "1:928408581054:web:21ea2dd1b5342342b13fef",
  measurementId: "G-3GCQDWRCNS",
};
initializeApp(firebaseConfig);
</script>

<style>
#app {
  font-family: "notoSansKR", Courier, monospace;
}

@import "./assets/reset.css";
@import "./assets/headerStyle.css";
@import "./assets/footerStyle.css";
@import "./assets/style.css";
@import "./assets/mobile.css";
</style>

<style lang="scss">
@import "./assets/scss/commons.scss";
@import "./assets/scss/surveyStyle.scss";
@import "./assets/scss/napaAdvisory.scss";
@import "./assets/scss/global.scss";
</style>
